import { Component, Input, Output, EventEmitter, OnInit, HostListener } from '@angular/core';
import { IPaginatorChange } from '../model/interfaces';

@Component({
    selector: 'app-list-paginator',
    templateUrl: './list-paginator.component.html',
    styleUrls: ['./list-paginator.component.scss']
})
export class ListPaginatorComponent implements OnInit {
    @Input() 
    set listId( id: string ) {
        this.paginatorPage.listId = id;
        this.paginatorPage.currentPageNo = 0;
    }

    @Input() isLoading: boolean = true;
    @Input() rowsPerPage: number = 10;
    @Input() currentPage: number = 0;
    @Input() totalPages: number = 0;

    @Input() backgroundColor: string = 'var(--tds-grey-100)';
    @Input() height: string = '48px';
    @Output() onPaginatorPage: EventEmitter<IPaginatorChange> = new EventEmitter<IPaginatorChange>(); 
    @Output() onPageSizeChanged: EventEmitter<number> = new EventEmitter<number>(); 
    
    paginatorPage: IPaginatorChange = { currentPageNo: 0, listId: '' };


   
    ngOnInit(): void {

    }

    @HostListener( 'document:keydown', ['$event'] )
    handleKeyboardEvent( event:KeyboardEvent ): any { 
        //
        if (event.shiftKey && event.code.toLowerCase() == 'pagedown') {
            event.stopImmediatePropagation();
            this.nextPage(1);
        }
        if (event.shiftKey && event.code.toLowerCase() == 'pageup') {
            event.stopImmediatePropagation();
            this.nextPage(-1);
        }
        if (event.shiftKey && event.code.toLowerCase() == 'end') {
            event.stopImmediatePropagation();
            this.lastPage();
        }
        if (event.shiftKey && event.code.toLowerCase() == 'home') {
            event.stopImmediatePropagation();
            this.firstPage();
        }
        return true;
    }

    isDisabledArrow(arrowDir: string): string {
        if (arrowDir == 'rigtharrow') {
            return this.currentPage + 1 >= this.totalPages ? 'arrow-button-disabled' : 'arrow-button';
        }
        return this.currentPage <= 0 ? 'arrow-button-disabled' : 'arrow-button';
    }

    isArrowDisabled(arrowDir: string): boolean {
        if (arrowDir == 'rigtharrow') {
            return this.currentPage + 1 >= this.totalPages ;
        }
        return this.currentPage <= 0 ;
    }

    nextPage(step: number): void {
        this.currentPage = this.currentPage + step;

        if (this.currentPage  >= this.totalPages ) this.currentPage = this.totalPages -1;
        if (this.currentPage  <= 0 ) this.currentPage = 0;

        this.paginatorPage.currentPageNo = this.currentPage;
        this.onPaginatorPage.emit( this.paginatorPage );
    }

    firstPage(): void {
        this.currentPage = 0;
        this.paginatorPage.currentPageNo =  this.currentPage;
        this.onPaginatorPage.emit( this.paginatorPage );
    }

    lastPage(): void {
        this.currentPage = this.totalPages - 1;
        this.paginatorPage.currentPageNo = this.currentPage;
        this.onPaginatorPage.emit( this.paginatorPage );
    }

    pageSizeChange(): void {
        if (this.rowsPerPage > 50)
            this.rowsPerPage = 50;
        this.onPageSizeChanged.emit(this.rowsPerPage);
    }

}
